import { BUSINESS } from "@/data/business";

export const WhatsAppButton = () => {
  const message = encodeURIComponent(
    "Hello Tira Spa, I would like to inquire about booking a massage session."
  );

  return (
    <a
      href={`https://wa.me/${BUSINESS.phoneClean.replace("+", "")}?text=${message}`}
      target="_blank"
      rel="noopener noreferrer"
      data-testid="sticky-whatsapp-button"
      aria-label="Chat with Tira Spa on WhatsApp"
      className="fixed z-[60] bottom-24 right-5 sm:bottom-28 sm:right-7 flex items-center justify-center w-12 h-12 sm:w-14 sm:h-14 rounded-full bg-[#25D366] text-white shadow-[0_12px_32px_-8px_rgba(37,211,102,0.55)] hover:scale-110 active:scale-95 transition-all duration-300 border border-white/10"
    >
      <svg
        viewBox="0 0 32 32"
        width="22"
        height="22"
        fill="currentColor"
        aria-hidden="true"
      >
        <path d="M16.004 2.667C8.64 2.667 2.67 8.636 2.67 16c0 2.655.772 5.13 2.11 7.223L2.667 29.333l6.31-1.991A13.273 13.273 0 0 0 16.004 29.333C23.367 29.333 29.337 23.364 29.337 16S23.367 2.667 16.004 2.667zm0 24.242a10.93 10.93 0 0 1-5.64-1.55l-.404-.24-4.016 1.267 1.287-3.916-.264-.42a10.907 10.907 0 0 1-1.69-5.85c0-6.02 4.908-10.93 10.927-10.93 6.02 0 10.93 4.91 10.93 10.93 0 6.019-4.91 10.709-10.93 10.709zm5.979-8.173c-.327-.164-1.937-.955-2.238-1.064-.3-.11-.518-.164-.736.164-.218.327-.845 1.064-1.036 1.282-.19.218-.382.245-.709.082-.327-.164-1.38-.509-2.628-1.622-.971-.866-1.627-1.936-1.818-2.263-.19-.327-.02-.504.164-.668.164-.164.368-.427.55-.64.183-.218.245-.373.368-.618.123-.245.062-.459-.027-.64-.09-.182-.805-1.936-1.104-2.65-.29-.695-.587-.6-.805-.613h-.686c-.218 0-.573.082-.877.4-.3.327-1.173 1.145-1.173 2.795s1.2 3.245 1.364 3.468c.164.218 2.263 3.455 5.487 4.705 3.223 1.25 3.223.835 3.804.782.582-.055 1.937-.79 2.21-1.555.272-.764.272-1.42.19-1.556-.082-.136-.3-.218-.627-.382z" />
      </svg>
    </a>
  );
};
